import React, { useMemo } from "react";
import useImageSize from "../../../../hooks/global/useImageSize";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { ListingRoundedImage } from "../listingRoundedImage/ListingRoundedImage";

export const ListingCoachAvatar = () => {
  const listingDataRedux = useSelector(
    (state: RootState) => state.trainingPlan.listingData
  );
  const [resizedProfileImage] = useImageSize({
    isProfile: true,
    originalFormat: true,
    imageUrl: listingDataRedux.user.avatarUrl,
    size: 500,
  });
  const size = useMemo(() => {
    if (listingDataRedux.collaborators.length === 1) {
      return 65;
    }

    if (listingDataRedux.collaborators.length === 2) {
      return 50;
    }

    return 72;
  }, [listingDataRedux.collaborators]);

  return (
    <ListingRoundedImage
      className="bottom-0 left-0"
      image={resizedProfileImage}
      title={listingDataRedux.user.name}
      size={size}
      useBorder={listingDataRedux.collaborators.length > 0 ? false : true}
    />
  );
};
